import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, EventEmitter, Input, Output, forwardRef, TemplateRef, ElementRef, Component, ChangeDetectionStrategy, ViewChild, ContentChild, ContentChildren, HostBinding, NgModule } from '@angular/core';
import * as i6 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i2 from '@firestitch/clear';
import { FsClearModule } from '@firestitch/clear';
import { Subject } from 'rxjs';
import { tap, debounceTime, filter, switchMap, takeUntil } from 'rxjs/operators';
import { random, trim, isObject } from 'lodash-es';
import * as i1 from '@angular/material/form-field';
import * as i4 from '@angular/material/core';

class FsAutocompleteHintDirective {
}
FsAutocompleteHintDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteHintDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompleteHintDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteHintDirective, selector: "[fsAutocompleteHint]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteHintDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompleteHint]'
                }]
        }] });

class FsAutocompletePrefixDirective {
}
FsAutocompletePrefixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompletePrefixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompletePrefixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompletePrefixDirective, selector: "[fsAutocompletePrefix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompletePrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompletePrefix]'
                }]
        }] });

class FsAutocompleteStaticDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.selected = new EventEmitter();
        this.isShow = true;
        this.isDisabled = false;
        this.show = (keyword) => true;
        this.disable = (keyword) => false;
    }
}
FsAutocompleteStaticDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteStaticDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompleteStaticDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteStaticDirective, selector: "[fsAutocompleteStatic],[fsAutocompleteStaticTemplate]", inputs: { show: "show", disable: "disable" }, outputs: { selected: "selected" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteStaticDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompleteStatic],[fsAutocompleteStaticTemplate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { show: [{
                type: Input
            }], disable: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });

class FsAutocompleteSuffixDirective {
}
FsAutocompleteSuffixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompleteSuffixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteSuffixDirective, selector: "[fsAutocompleteSuffix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompleteSuffix]'
                }]
        }] });

class FsAutocompleteTemplateDirective {
}
FsAutocompleteTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompleteTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteTemplateDirective, selector: "[fsAutocompleteTemplate]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompleteTemplate]'
                }]
        }] });

class FsAutocompleteNoResultsDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.isShow = true;
        this.show = (keyword) => true;
    }
}
FsAutocompleteNoResultsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteNoResultsDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsAutocompleteNoResultsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteNoResultsDirective, selector: "[fsAutocompleteNoResults]", inputs: { show: "show" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteNoResultsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAutocompleteNoResults]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { show: [{
                type: Input
            }] } });

class FsAutocompleteComponent {
    constructor(_cdRef, _elRef) {
        this._cdRef = _cdRef;
        this._elRef = _elRef;
        this.suffix = null;
        this.prefix = null;
        this.hintTemplate = null;
        this.formWrapper = true;
        this.placeholder = '';
        this.fetchOnFocus = false;
        this.readonly = false;
        this.required = false;
        this.disabled = false;
        this.hint = null;
        this.panelWidth = null;
        this.cleared = new EventEmitter();
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        this.data = [];
        this.keyword = '';
        this.panelClasses = ['fs-autocomplete-panel'];
        this.noResults = false;
        this.name = 'autocomplete_'.concat(random(1, 9999999));
        this.model = null;
        this.searching = false;
        this._destroy$ = new Subject();
        this._keyword$ = new Subject();
        this._ignoreKeys = [
            'Enter', 'Escape', 'ArrowUp', 'ArrowLeft', 'ArrowRight',
            'ArrowDown', 'Alt', 'Control', 'Shift',
        ];
        this.display = (data) => {
            if (data && this.displayWith) {
                return this.displayWith(data);
            }
            return '';
        };
    }
    set setPanelClass(value) {
        this.panelClasses.push(value);
    }
    set showClear(value) {
        this._showClear = value;
        this._cdRef.detectChanges();
    }
    get showClear() {
        return this._showClear;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    ngOnInit() {
        // Because the input display is set natively the delay
        // ensure its set after this.keyword
        setTimeout(() => {
            this._updateKeywordDisplay();
        });
        this._keyword$
            .pipe(tap(() => {
            this.searching = true;
            this.panelClasses = [
                ...this.panelClasses,
                'searching',
            ];
            if (this.noResultsDirective) {
                this.noResultsDirective.isShow = this.noResultsDirective.show(this._getKeyword());
            }
            this.staticDirectives.forEach((staticDirective) => {
                staticDirective.isShow = staticDirective.show(this._getKeyword());
                staticDirective.isDisabled = staticDirective.disable(this._getKeyword());
            });
            this._cdRef.markForCheck();
        }), debounceTime(200), filter((event) => {
            return !event || this._ignoreKeys.indexOf(event.key) === -1;
        }), switchMap((event) => {
            return this.fetch(trim(event.target.value))
                .pipe(tap((response) => {
                this.data = response;
                this.noResults = !response.length;
                this._cdRef.markForCheck();
                this.autocompleteTrigger.openPanel();
                this.searching = false;
                this.panelClasses = this.panelClasses
                    .filter((name) => name !== 'searching');
            }), takeUntil(this._destroy$));
        }), takeUntil(this._destroy$))
            .subscribe(() => {
            this._onTouched();
        });
        this.opened
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            //Hack: disable the focus event when the panel is opened to avoid
            //optionSelected() calling input.focus() too early
            this._focus = this.keywordInput.nativeElement.focus;
            this.keywordInput.nativeElement.focus = () => {
                //dummy
            };
            setTimeout(() => {
                const width = this._elRef.nativeElement.getBoundingClientRect().width;
                const panel = this.autocomplete.panel?.nativeElement;
                if (panel) {
                    panel.style.minWidth = `${width}px`;
                }
            }, 200);
        });
        this.closed
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this.keywordInput.nativeElement.focus = this._focus;
        });
    }
    ngOnChanges(changes) {
        if (changes.disabled && this.showClear === undefined) {
            this.showClear = this.disabled
                ? false
                : true;
        }
    }
    load() {
        this.searching = true;
        this._keyword$.next({ target: { value: this._getKeyword() } });
    }
    focus() {
        this.keywordInput.nativeElement.focus();
    }
    inputFocus() {
        if (this.readonly || this.disabled) {
            return;
        }
        if (this.fetchOnFocus) {
            if (!this.model) {
                this.load();
            }
        }
    }
    inputBlur() {
        if (this.readonly || this.disabled) {
            return;
        }
        setTimeout(() => {
            if (!this.model) {
                this.clearKeyword();
            }
            this._updateKeywordDisplay();
            this.clearResults();
            this.close();
        }, 200);
    }
    select(value) {
        if (isObject(value) && value.staticOptionIndex !== undefined) {
            this.staticSelect(value.staticOptionIndex);
        }
        else {
            this.model = value;
            this.data = [];
            this._updateKeywordDisplay();
            this._onChange(value);
        }
        this.clearResults();
        this.close();
    }
    optionSelected(event) {
        this.select(event.option.value);
        this.close();
    }
    close() {
        this.autocompleteTrigger.closePanel();
    }
    writeValue(value) {
        this.model = value;
        this._updateKeywordDisplay();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    input(event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if (!event.target.value.length) {
            return this.clear();
        }
        this._keyword$.next(event);
    }
    keyDown(event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if (event.code === 'Tab') {
            if (this.autocompleteTrigger.activeOption) {
                this.select(this.autocompleteTrigger.activeOption.value);
            }
        }
        else if (event.code === 'Backspace') {
            if (this.model) {
                this.clearModel();
                this.clearKeyword();
            }
        }
        else if (!this._isWindows() && !this._isMacOS()) {
            if (this._ignoreKeys.indexOf(event.key) === -1) {
                this.searching = true;
                this.data = [];
                if (this.model) {
                    this.clear();
                }
            }
        }
    }
    keyUp(event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if (event.code === 'Backspace' && !event.target.value.length) {
            this.load();
        }
    }
    staticSelect(index) {
        const keyword = this.keyword;
        if (!this.model) {
            this.keywordNgModel.reset();
        }
        const staticDirective = this.staticDirectives.toArray()[index];
        staticDirective.selected.emit(keyword);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    clearResults() {
        this.data = [];
        this.noResults = false;
    }
    clear(closePanel = true) {
        this.clearResults();
        if (closePanel) {
            this.close();
        }
        this.clearModel();
        this.clearKeyword();
    }
    clearModel() {
        this.model = null;
        this._onChange(null);
    }
    clearKeyword() {
        this.keyword = null;
        this._updateKeywordDisplay();
    }
    clearClick(event) {
        event.stopPropagation();
        this.clearModel();
        this.keywordInput.nativeElement.value = null;
        this.cleared.emit();
        this.keywordInput.nativeElement.focus();
        this.load();
    }
    _updateKeywordDisplay() {
        const value = this.model ? this.display(this.model) : '';
        this.keyword = this.model;
        this.keywordInput.nativeElement.value = value;
        this._cdRef.markForCheck();
    }
    _getKeyword() {
        return this.keywordInput.nativeElement.value;
    }
    _isMacOS() {
        return navigator.platform.indexOf('Mac') > -1;
    }
    _isWindows() {
        return navigator.platform.indexOf('Win') > -1;
    }
}
FsAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FsAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAutocompleteComponent, selector: "fs-autocomplete", inputs: { fetch: "fetch", displayWith: "displayWith", placeholder: "placeholder", fetchOnFocus: "fetchOnFocus", readonly: "readonly", required: "required", disabled: "disabled", formFieldClass: "formFieldClass", appearance: "appearance", hint: "hint", panelWidth: "panelWidth", setPanelClass: ["panelClass", "setPanelClass"], showClear: "showClear" }, outputs: { cleared: "cleared", opened: "opened", closed: "closed" }, host: { properties: { "class.fs-form-wrapper": "this.formWrapper" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsAutocompleteComponent),
            multi: true,
        },
    ], queries: [{ propertyName: "template", first: true, predicate: FsAutocompleteTemplateDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "noResultsDirective", first: true, predicate: FsAutocompleteNoResultsDirective, descendants: true }, { propertyName: "suffix", first: true, predicate: FsAutocompleteSuffixDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "prefix", first: true, predicate: FsAutocompletePrefixDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "hintTemplate", first: true, predicate: FsAutocompleteHintDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "staticDirectives", predicate: FsAutocompleteStaticDirective }], viewQueries: [{ propertyName: "autocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true, static: true }, { propertyName: "autocomplete", first: true, predicate: MatAutocomplete, descendants: true }, { propertyName: "keywordInput", first: true, predicate: ["keywordInput"], descendants: true, read: ElementRef, static: true }, { propertyName: "keywordNgModel", first: true, predicate: ["keywordNgModel"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<mat-form-field [appearance]=\"appearance\" [class]=\"formFieldClass\">\n  <mat-label>{{placeholder}}</mat-label>\n  <input\n    #keywordInput\n    #keywordNgModel=\"ngModel\"\n    matInput\n    type=\"search\"\n    [fsClear]=\"(showClear === undefined ? true : showClear) && model\"\n    (cleared)=\"clearClick($event)\"\n    [(ngModel)]=\"keyword\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [required]=\"required\"\n    (focus)=\"inputFocus()\"\n    (blur)=\"inputBlur()\"\n    (input)=\"input($event)\"\n    (keydown)=\"keyDown($event)\"\n    (keyup)=\"keyUp($event)\"\n    [matAutocomplete]=\"userAutocompleteInput\">\n  <div *ngIf=\"prefix\" matPrefix class=\"prefix\">\n    <ng-container\n      [ngTemplateOutlet]=\"prefix\"\n      [ngTemplateOutletContext]=\"{ data: model }\">\n    </ng-container>\n  </div>\n  <div *ngIf=\"!disabled\" matSuffix class=\"suffix\">\n    <ng-container\n      [ngTemplateOutlet]=\"suffix\"\n      [ngTemplateOutletContext]=\"{ data: model }\">\n    </ng-container>\n  </div>\n  <mat-autocomplete\n      #userAutocompleteInput=\"matAutocomplete\"\n      [autoActiveFirstOption]=\"!!keyword\"\n      [panelWidth]=\"panelWidth\"\n      (opened)=\"opened.emit()\"\n      (closed)=\"closed.emit()\"\n      [class]=\"panelClasses\"\n      [displayWith]=\"display\"\n      (optionSelected)=\"optionSelected($event)\">\n    <mat-option \n        *ngFor=\"let item of data\" [value]=\"item\"\n        class=\"general-option\">\n      <ng-container\n        [ngTemplateOutlet]=\"template\"\n        [ngTemplateOutletContext]=\"{ data: item }\">\n      </ng-container>\n    </mat-option>\n\n    <ng-container *ngIf=\"noResults\">\n      <ng-container *ngIf=\"noResultsDirective; else noResultsOption\">\n        <ng-container *ngIf=\"noResultsDirective.isShow\">\n          <ng-template\n            [ngTemplateOutlet]=\"noResultsDirective.templateRef\"\n            [ngTemplateOutletContext]=\"{ $implicit: keyword }\">\n          </ng-template>\n        </ng-container>\n      </ng-container>\n      <ng-template #noResultsOption>\n        <mat-option disabled class=\"no-results\">\n          No results <ng-container *ngIf=\"keyword\">for \"{{keyword}}\"</ng-container>\n        </mat-option>\n      </ng-template>\n    </ng-container>      \n    <ng-container *ngIf=\"!model && staticDirectives?.length\">\n      <div class=\"static-templates\">\n        <ng-container *ngFor=\"let staticTemplate of staticDirectives; let i = index\">\n          <ng-container *ngIf=\"staticTemplate.isShow\">\n            <mat-option\n                class=\"static-option\"\n                [value]=\"{ staticOptionIndex: i }\"\n                [disabled]=\"staticTemplate.isDisabled\"\n                [ngClass]=\"{ 'static-option-first': !i }\">\n              <ng-template\n                [ngTemplateOutlet]=\"staticTemplate.templateRef\"\n                [ngTemplateOutletContext]=\"{ $implicit: keyword }\">\n              </ng-template>\n            </mat-option>\n          </ng-container>\n        </ng-container>\n      </div>\n    </ng-container>\n  </mat-autocomplete>\n\n  <mat-hint *ngIf=\"hint\">{{ hint }}</mat-hint>\n  <mat-hint *ngIf=\"hintTemplate\">\n    <ng-container\n      [ngTemplateOutlet]=\"hintTemplate\">\n    </ng-container>\n  </mat-hint>\n</mat-form-field>\n", styles: ["::ng-deep .fs-autocomplete-panel.searching .mat-option.general-option{opacity:.5}::ng-deep .fs-autocomplete-panel .static-templates{position:sticky;bottom:0;width:100%;background:#fff;border-top:1px solid #e0e0e0}::ng-deep .fs-autocomplete-panel.mat-autocomplete-hidden{visibility:visible!important}.mat-form-field{width:100%}.clear{cursor:pointer}.suffix{display:flex}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i2.FsClearComponent, selector: "[fsClear]", inputs: ["ngModel", "fsClear"], outputs: ["ngModelChange", "cleared"] }, { type: i3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i1.MatLabel, selector: "mat-label" }, { type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.MatPrefix, selector: "[matPrefix]" }, { type: i7.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1.MatSuffix, selector: "[matSuffix]" }, { type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-autocomplete', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsAutocompleteComponent),
                            multi: true,
                        },
                    ], template: "<mat-form-field [appearance]=\"appearance\" [class]=\"formFieldClass\">\n  <mat-label>{{placeholder}}</mat-label>\n  <input\n    #keywordInput\n    #keywordNgModel=\"ngModel\"\n    matInput\n    type=\"search\"\n    [fsClear]=\"(showClear === undefined ? true : showClear) && model\"\n    (cleared)=\"clearClick($event)\"\n    [(ngModel)]=\"keyword\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [required]=\"required\"\n    (focus)=\"inputFocus()\"\n    (blur)=\"inputBlur()\"\n    (input)=\"input($event)\"\n    (keydown)=\"keyDown($event)\"\n    (keyup)=\"keyUp($event)\"\n    [matAutocomplete]=\"userAutocompleteInput\">\n  <div *ngIf=\"prefix\" matPrefix class=\"prefix\">\n    <ng-container\n      [ngTemplateOutlet]=\"prefix\"\n      [ngTemplateOutletContext]=\"{ data: model }\">\n    </ng-container>\n  </div>\n  <div *ngIf=\"!disabled\" matSuffix class=\"suffix\">\n    <ng-container\n      [ngTemplateOutlet]=\"suffix\"\n      [ngTemplateOutletContext]=\"{ data: model }\">\n    </ng-container>\n  </div>\n  <mat-autocomplete\n      #userAutocompleteInput=\"matAutocomplete\"\n      [autoActiveFirstOption]=\"!!keyword\"\n      [panelWidth]=\"panelWidth\"\n      (opened)=\"opened.emit()\"\n      (closed)=\"closed.emit()\"\n      [class]=\"panelClasses\"\n      [displayWith]=\"display\"\n      (optionSelected)=\"optionSelected($event)\">\n    <mat-option \n        *ngFor=\"let item of data\" [value]=\"item\"\n        class=\"general-option\">\n      <ng-container\n        [ngTemplateOutlet]=\"template\"\n        [ngTemplateOutletContext]=\"{ data: item }\">\n      </ng-container>\n    </mat-option>\n\n    <ng-container *ngIf=\"noResults\">\n      <ng-container *ngIf=\"noResultsDirective; else noResultsOption\">\n        <ng-container *ngIf=\"noResultsDirective.isShow\">\n          <ng-template\n            [ngTemplateOutlet]=\"noResultsDirective.templateRef\"\n            [ngTemplateOutletContext]=\"{ $implicit: keyword }\">\n          </ng-template>\n        </ng-container>\n      </ng-container>\n      <ng-template #noResultsOption>\n        <mat-option disabled class=\"no-results\">\n          No results <ng-container *ngIf=\"keyword\">for \"{{keyword}}\"</ng-container>\n        </mat-option>\n      </ng-template>\n    </ng-container>      \n    <ng-container *ngIf=\"!model && staticDirectives?.length\">\n      <div class=\"static-templates\">\n        <ng-container *ngFor=\"let staticTemplate of staticDirectives; let i = index\">\n          <ng-container *ngIf=\"staticTemplate.isShow\">\n            <mat-option\n                class=\"static-option\"\n                [value]=\"{ staticOptionIndex: i }\"\n                [disabled]=\"staticTemplate.isDisabled\"\n                [ngClass]=\"{ 'static-option-first': !i }\">\n              <ng-template\n                [ngTemplateOutlet]=\"staticTemplate.templateRef\"\n                [ngTemplateOutletContext]=\"{ $implicit: keyword }\">\n              </ng-template>\n            </mat-option>\n          </ng-container>\n        </ng-container>\n      </div>\n    </ng-container>\n  </mat-autocomplete>\n\n  <mat-hint *ngIf=\"hint\">{{ hint }}</mat-hint>\n  <mat-hint *ngIf=\"hintTemplate\">\n    <ng-container\n      [ngTemplateOutlet]=\"hintTemplate\">\n    </ng-container>\n  </mat-hint>\n</mat-form-field>\n", styles: ["::ng-deep .fs-autocomplete-panel.searching .mat-option.general-option{opacity:.5}::ng-deep .fs-autocomplete-panel .static-templates{position:sticky;bottom:0;width:100%;background:#fff;border-top:1px solid #e0e0e0}::ng-deep .fs-autocomplete-panel.mat-autocomplete-hidden{visibility:visible!important}.mat-form-field{width:100%}.clear{cursor:pointer}.suffix{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { autocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger, { static: true }]
            }], autocomplete: [{
                type: ViewChild,
                args: [MatAutocomplete]
            }], template: [{
                type: ContentChild,
                args: [FsAutocompleteTemplateDirective, { read: TemplateRef, static: true }]
            }], staticDirectives: [{
                type: ContentChildren,
                args: [FsAutocompleteStaticDirective]
            }], noResultsDirective: [{
                type: ContentChild,
                args: [FsAutocompleteNoResultsDirective]
            }], suffix: [{
                type: ContentChild,
                args: [FsAutocompleteSuffixDirective, { read: TemplateRef, static: true }]
            }], prefix: [{
                type: ContentChild,
                args: [FsAutocompletePrefixDirective, { read: TemplateRef, static: true }]
            }], hintTemplate: [{
                type: ContentChild,
                args: [FsAutocompleteHintDirective, { read: TemplateRef, static: true }]
            }], formWrapper: [{
                type: HostBinding,
                args: ['class.fs-form-wrapper']
            }], keywordInput: [{
                type: ViewChild,
                args: ['keywordInput', { static: true, read: ElementRef }]
            }], keywordNgModel: [{
                type: ViewChild,
                args: ['keywordNgModel', { static: true }]
            }], fetch: [{
                type: Input
            }], displayWith: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], fetchOnFocus: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], formFieldClass: [{
                type: Input
            }], appearance: [{
                type: Input
            }], hint: [{
                type: Input
            }], panelWidth: [{
                type: Input
            }], setPanelClass: [{
                type: Input,
                args: ['panelClass']
            }], showClear: [{
                type: Input
            }], cleared: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }] } });

class FsAutocompleteModule {
}
FsAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteModule, declarations: [FsAutocompleteComponent,
        FsAutocompleteTemplateDirective,
        FsAutocompleteSuffixDirective,
        FsAutocompletePrefixDirective,
        FsAutocompleteStaticDirective,
        FsAutocompleteNoResultsDirective,
        FsAutocompleteHintDirective], imports: [CommonModule,
        FormsModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatInputModule,
        MatIconModule,
        FsClearModule], exports: [FsAutocompleteComponent,
        FsAutocompleteTemplateDirective,
        FsAutocompleteSuffixDirective,
        FsAutocompletePrefixDirective,
        FsAutocompleteStaticDirective,
        FsAutocompleteNoResultsDirective,
        FsAutocompleteHintDirective] });
FsAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteModule, providers: [], imports: [[
            CommonModule,
            FormsModule,
            MatAutocompleteModule,
            MatChipsModule,
            MatInputModule,
            MatIconModule,
            FsClearModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatAutocompleteModule,
                        MatChipsModule,
                        MatInputModule,
                        MatIconModule,
                        FsClearModule,
                    ],
                    exports: [
                        FsAutocompleteComponent,
                        FsAutocompleteTemplateDirective,
                        FsAutocompleteSuffixDirective,
                        FsAutocompletePrefixDirective,
                        FsAutocompleteStaticDirective,
                        FsAutocompleteNoResultsDirective,
                        FsAutocompleteHintDirective,
                    ],
                    declarations: [
                        FsAutocompleteComponent,
                        FsAutocompleteTemplateDirective,
                        FsAutocompleteSuffixDirective,
                        FsAutocompletePrefixDirective,
                        FsAutocompleteStaticDirective,
                        FsAutocompleteNoResultsDirective,
                        FsAutocompleteHintDirective,
                    ],
                    providers: [],
                }]
        }] });

// Modules

/**
 * Generated bundle index. Do not edit.
 */

export { FsAutocompleteComponent, FsAutocompleteHintDirective, FsAutocompleteModule, FsAutocompleteNoResultsDirective, FsAutocompletePrefixDirective, FsAutocompleteStaticDirective, FsAutocompleteSuffixDirective, FsAutocompleteTemplateDirective };
